<script setup>
defineProps({
  filteredCount: { type: Number, default: 0 },
  page: { type: Number, default: 1 },
  totalPages: { type: Number, default: 1 },
})
</script>

<template>
  <div class="users-summary-bar muted">
    <strong>Users:</strong> {{ filteredCount }}
    <span>Page {{ page }} of {{ totalPages }}</span>
  </div>
</template>

<style scoped>
.users-summary-bar { display: flex; justify-content: space-between; gap: 0.75rem; align-items: center; }
.muted { color: #6b7280; }
</style>

